// extracted by mini-css-extract-plugin
export default {"apply-content":"index_apply-content__XSSCD","btn":"index_btn__04ldd"};